// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BNt6","top":"styles_top__1yjb1","left":"styles_left__2KMo4","description":"styles_description__FXTTJ"};